import { forEach, map } from "lodash";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import Header from "../../components/custom/Header";
import { useSelector, useDispatch } from "react-redux";
import {
  showResponseMessage,
  setBusy,
  setIdle,
  setAngpaoStatus,
  setShowAngpaoTnc,
  showMessage
} from "../../redux/AppAction.js";
import ApiEngine from "../../util/ApiEngine.js";
import { ApiKey, ApiUrl, WebUrl, LanguageKey, TransactionType, PanelType, LanguageOption, SessionKey, AlertTypes } from "../../util/Constant";
import { createFormBody, createMultiPartFormBody, numberWithCurrencyFormat, stringIsNullOrEmpty } from "../../util/Util";
import { Modal, ModalBody } from "reactstrap";
import moment from "moment";
import { actions } from "react-table";
import 'moment/locale/en-gb';
import parse from 'react-html-parser';
import ContentHeader from "components/content/header";
import AP_Back from '../../assets/img/v3/angpao/AP_Back.png';
import AP_Front from '../../assets/img/v3/angpao/AP_Front.png';
import AP_Close from '../../assets/img/v3/angpao/AP_Close.png';
import AP_Open from '../../assets/img/v3/angpao/AP_Open.png';
import Light_base from '../../assets/img/v3/angpao/Light_base.png';
import Light_Shine from '../../assets/img/v3/angpao/Light_Shine.png';
import Ticker_base from '../../assets/img/v3/angpao/Ticker_base.png';
/// <summary>
/// Author: -
/// </summary>
const Angpao = (props) => {
  var _dispatch = useDispatch();
  const { t } = useTranslation();
  const _history = useHistory();
  const { isLoggedIn } = useSelector((state) => state.authState);
  const angpaoStatus = useSelector((state) => state.appState.angpaoStatus);
  const [angpaoDrawLength, setAngpaoDrawLength] = useState(0);
  const [angpaoDrawList, setAngpaoDrawList] = useState([]);
  const [claimAngpaoItem, setClaimAngpaoItem] = useState("");
  const [openClaimModal, setOpenClaimModal] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    init();
    if (isLoggedIn) {
      angpaoDrawRecord();
    }
  }, []);

  const init = async () => {
    let responseJson = await ApiEngine.get(ApiUrl._API_GET_ANGPAO_STATUS);
    if (responseJson[ApiKey._API_SUCCESS_KEY]) {
      let statusActive = responseJson[ApiKey._API_DATA_KEY] === true;
      _dispatch(setAngpaoStatus(statusActive));
      if (statusActive) {

      }
      else {
        _dispatch(showResponseMessage(false, t("ANGPAO_INACTIVE")));
        setTimeout(() => window.location.replace(WebUrl._URL_MAIN), 2000);
      }
    }
  }

  const angpaoDrawRecord = async () => {
    let responseJson = await ApiEngine.get(ApiUrl._API_GET_ANGPAO_DRAW_RECORD);
    if (responseJson[ApiKey._API_SUCCESS_KEY]) {
      let data = responseJson[ApiKey._API_DATA_KEY];
      if (!stringIsNullOrEmpty(data)) {
        setAngpaoDrawLength(data.length);
        setAngpaoDrawList(data);
      } else {
        setAngpaoDrawLength(0);
        setAngpaoDrawList([]);
      }
    }
  }

  const handleSubmit = async () => {
    setIsOpen(true);
    if (isLoggedIn) {
      let responseJson = await ApiEngine.post(ApiUrl._API_CREATE_ANGPAO_TRANSACTION);
      if (responseJson[ApiKey._API_SUCCESS_KEY]) {
        const angpao = responseJson[ApiKey._API_DATA_KEY];
        setOpenClaimModal(true);
        setClaimAngpaoItem(angpao);
        angpaoDrawRecord();
      } else {
        _dispatch(
          showResponseMessage(
            responseJson[ApiKey._API_SUCCESS_KEY],
            responseJson[ApiKey._API_MESSAGE_KEY]
          )
        );
      }
    } else {
      _dispatch(
        showMessage({
          type: AlertTypes._INFO,
          content: t("PLEASE_LOGIN_FIRST"),
          onConfirm: () => {
          },
        })
      );
    }
  }

  const closeClaimedModal = () => {
    setOpenClaimModal(false);
    setClaimAngpaoItem("");
    setIsOpen(false);
  }

  const checkIsDepositWhenEvent = async () => {
    if (isLoggedIn) {
      const responseJson = await ApiEngine.get(ApiUrl._API_CHECK_IS_DEPOSIT_WHEN_EVENT);
      if (responseJson[ApiKey._API_SUCCESS_KEY]) {
        if (!responseJson[ApiKey._API_DATA_KEY]) {
          _dispatch(setShowAngpaoTnc(true))
        }
      }
    }
  }

  return (
    <>
      {angpaoStatus &&
        <>
        <div className="angpao-main-container">
          <div onClick={() => angpaoDrawLength > 0 ? handleSubmit() : checkIsDepositWhenEvent()}>
              <div className="red-envelope-container">
                <div>
                  <img src={AP_Open} alt="Open" className={`red-envelope-open ${isOpen ? 'open' : ''}`} />
                  <img src={Light_base} alt="Light_base" className={`red-envelope-Light_base ${isOpen ? 'open' : ''}`} />
                  <img src={Ticker_base} alt="Ticker_base" className={`red-envelope-Ticker_base ${isOpen ? 'open' : ''} ${openClaimModal ? 'open-claim' : ''}`} />
                  <img src={Light_Shine} alt="Light_Shine" className={`red-envelope-Light_Shine ${isOpen ? 'open' : ''}`} />
                  {claimAngpaoItem && <div className="red-envelope-claim-text">{t("ANGPAO_AMOUNT", { value: claimAngpaoItem })}</div>}
                </div>
                <div>
                  <img src={AP_Back} alt="Back" className="red-envelope-back" />
                  <img src={AP_Front} alt="Front" className="red-envelope-front" />
                  <img src={AP_Close} alt="Close" className={`red-envelope-close ${isOpen ? 'open' : ''}`} />
                </div>
              </div>
          </div>
          <div className="angpao-content-div">
          {openClaimModal &&
            <div className="collect-angpao" onClick={() => closeClaimedModal()}>
              {t("COLLECT")}
            </div>
          }
          {
            isLoggedIn &&
            <div className="angpao-draw-length">
              {t("ANGPAO_DRAW_LENGTH", { value: angpaoDrawLength })}
            </div>
            }
            <div style={{ cursor: 'pointer' }} onClick={() => _dispatch(setShowAngpaoTnc(true))}>
                {t("TNC")}
              </div>
            </div>
          </div>
        </>
      }
    </>
  );
};

export default Angpao;
